var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "slide-fade-left" } }, [
    _vm.item
      ? _c(
          "div",
          {
            staticClass: "sidecart__line-item",
            class: [
              _vm.itemClass,
              _vm.inKit ? "kit-" + _vm._kitId + "-" + (_vm.line - 1) : "",
              _vm.inKit ? "kit-item" : ""
            ]
          },
          [
            _vm.productBadge
              ? _c(
                  "span",
                  {
                    staticClass: "sidecart__line-item-badge badge",
                    class: _vm.$store.state.badgeColorMap[_vm.productBadge]
                  },
                  [_vm._v(_vm._s(_vm.productBadge))]
                )
              : _vm._e(),
            _c("a", {
              staticClass: "sidecart__line-item__image-wrapper",
              style: "backgroundImage: url(" + _vm.item.image + ")",
              attrs: { alt: _vm.item.product_title, href: _vm.item.url }
            }),
            _c("div", { staticClass: "sidecart__line-item__content" }, [
              _c("div", { staticClass: "sidecart__line-item__info" }, [
                _c("div", { staticClass: "sidecart__line-item__header" }, [
                  _c(
                    "a",
                    {
                      staticClass: "sidecart__line-item__title",
                      attrs: { href: _vm.item.url }
                    },
                    [_vm._v(_vm._s(_vm.itemName))]
                  ),
                  !_vm.disableRemove
                    ? _c(
                        "button",
                        {
                          staticClass: "sidecart__line-item__remove",
                          attrs: {
                            label: "Remove",
                            "aria-label": "Remove item"
                          },
                          on: { click: _vm.removeItem }
                        },
                        [
                          _c("icon", { attrs: { name: "close", size: "15px" } })
                        ],
                        1
                      )
                    : _vm._e()
                ]),
                _c(
                  "div",
                  { staticClass: "sidecart__line-item__option-list" },
                  [
                    _c(
                      "span",
                      {
                        staticClass:
                          "sidecart__line-item__option sidecart__line-item__sku body-sm"
                      },
                      [_c("span", [_vm._v(_vm._s(_vm.item.sku))])]
                    ),
                    _vm._l(_vm.item.options_with_values, function(option) {
                      return option.value !== "Default Title"
                        ? _c(
                            "span",
                            {
                              staticClass: "sidecart__line-item__option body-sm"
                            },
                            [
                              _vm._v(
                                _vm._s(option.name) +
                                  ": " +
                                  _vm._s(option.value)
                              )
                            ]
                          )
                        : _vm._e()
                    }),
                    _vm._l(_vm.item.properties, function(
                      prop_value,
                      prop_name
                    ) {
                      return _vm.hasPropertiesToShow
                        ? _c(
                            "span",
                            {
                              staticClass:
                                "sidecart__line-item__option sidecart__line-item__properties body-sm"
                            },
                            [
                              _vm._v(
                                _vm._s(prop_name) + ": " + _vm._s(prop_value)
                              )
                            ]
                          )
                        : _vm._e()
                    })
                  ],
                  2
                ),
                !_vm.disableQuantity && !_vm.IS_BOURDAIN && !_vm.isPDPDesign2
                  ? _c(
                      "div",
                      { staticClass: "sidecart__line-item__quantity" },
                      [
                        _c(
                          "button",
                          {
                            staticClass:
                              "sidecart__line-item__quantity__change",
                            attrs: {
                              label: "Decrement Count",
                              disabled: _vm.item.quantity === 1,
                              "aria-label": "Decrease count"
                            },
                            on: { click: _vm.decrement }
                          },
                          [
                            _c("icon", {
                              staticClass: "fill-black",
                              attrs: { name: "minus", size: "12px" }
                            })
                          ],
                          1
                        ),
                        _c(
                          "p",
                          {
                            staticClass:
                              "sidecart__line-item__quantity__label body-md"
                          },
                          [_vm._v(_vm._s(_vm.item.quantity))]
                        ),
                        _c(
                          "button",
                          {
                            staticClass:
                              "sidecart__line-item__quantity__change",
                            attrs: {
                              label: "Increment Count",
                              "aria-label": "Increase count"
                            },
                            on: { click: _vm.increment }
                          },
                          [
                            _c("icon", {
                              staticClass: "fill-black",
                              attrs: { name: "plus", size: "14px" }
                            })
                          ],
                          1
                        )
                      ]
                    )
                  : _vm._e(),
                !_vm.disableQuantity && (_vm.IS_BOURDAIN || _vm.isPDPDesign2)
                  ? _c(
                      "div",
                      [
                        _c("quantity-selector", {
                          attrs: { value: _vm.item.quantity },
                          on: { input: _vm.updateQuantity }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ]),
              _c("div", { staticClass: "sidecart__line-item__details" }, [
                _c("p", { staticClass: "sidecart__line-item__price" }, [
                  _vm.item.line_price > 0
                    ? _c(
                        "span",
                        {
                          class: {
                            "sidecart__line-item__price--discount":
                              _vm.isDiscounted
                          }
                        },
                        [
                          _c("span", { staticClass: "visually-hidden" }, [
                            _vm._v("Now: ")
                          ]),
                          _vm._v(
                            _vm._s(
                              _vm._f("moneyWithoutDecimals")(
                                _vm.item.line_price
                              )
                            )
                          )
                        ]
                      )
                    : _c("span", [
                        _c("span", { staticClass: "visually-hidden" }, [
                          _vm._v("Now: ")
                        ]),
                        _vm._v("FREE")
                      ]),
                  _vm.isDiscounted
                    ? _c(
                        "span",
                        {
                          staticClass: "sidecart__line-item__price--compare-at"
                        },
                        [
                          _c("span", { staticClass: "visually-hidden" }, [
                            _vm._v("Was: ")
                          ]),
                          _vm._v(
                            _vm._s(
                              _vm._f("moneyWithoutDecimals")(_vm.comparePrice)
                            )
                          )
                        ]
                      )
                    : _vm._e()
                ])
              ])
            ])
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }